const Navbar = (props) => {
  const { pathname } = props;
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 10 }}>
      <a className="navbar-brand" href="/realestate">Home</a>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav">
          <li className={`nav-item ${pathname === "/realestate/frontyard" ? "active" : ""}`}>
            <a className="nav-link" href="/realestate/frontyard">FrontYard</a>
          </li>
          <li className={`nav-item ${pathname === "/realestate/livingarea" ? "active" : ""}`}>
            <a className="nav-link" href="/realestate/livingarea">LivingArea</a>
          </li>
          <li className={`nav-item ${pathname === "/realestate/environment-map" ? "active" : ""}`}>
            <a className="nav-link" href="/realestate/environment-map">EnvironmentMap</a>
          </li>
          <li className={`nav-item ${pathname === "/realestate/education-map" ? "active" : ""}`}>
            <a className="nav-link" href="/realestate/education-map">EducationMap</a>
          </li>
          <li className={`nav-item ${pathname === "/realestate/complex" ? "active" : ""}`}>
            <a className="nav-link" href="/realestate/complex">Complex</a>
          </li>
          <li className={`nav-item ${pathname === "/realestate/complex-area" ? "active" : ""}`}>
            <a className="nav-link" href="/realestate/complex-area">ComplexArea</a>
          </li>
          <li className={`nav-item ${pathname === "/realestate/complex-area2" ? "active" : ""}`}>
            <a className="nav-link" href="/realestate/complex-area2">ComplexAreaV2</a>
          </li>
          <li className={`nav-item ${pathname === "/realestate/complex-area-map" ? "active" : ""}`}>
            <a className="nav-link" href="/realestate/complex-area-map">ComplexAreaMap</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export { Navbar };
